<template>
  <el-button 
    v-bind="$attrs"
    :disabled="!!t || disabled"
    @click="handleClick"
   >
    <template v-if="!!t">
      {{time}}s内不可操作
    </template>
    <template v-else>
      <slot>更新</slot>
    </template>
  </el-button>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'UpdateTimeButton',
  props: ['disabled', 'date'],
  data() {
    return {
      time: 0,
      t: null
    }
  },
  watch: {
    date(n) {
      if (n&&n>0) {
        this.t&&clearInterval(this.t);
        this.updateTime(n)
      }
    }
  },
  methods: {
    handleClick(e) {
      this.updateTime()
      this.$emit('click', e)
    },
    updateTime(time = 300) {
      this.time = time;
      this.t = setInterval(()=>{
        if (this.time<=0) {
          clearInterval(this.t);
          this.t=null
        }
        this.time--;
      }, 1000)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>